import SmoothScrollbar from 'smooth-scrollbar/dist/smooth-scrollbar.js'

const TvnSmoothScrollbar = {
	init: function () {
		const scrollbarElements = document.querySelectorAll('.smooth-scrollbar')
		scrollbarElements.forEach(function (element) {
			const scrollbar = SmoothScrollbar.init(element, {
				alwaysShowTracks: false,
			})

			const todayElement = element.querySelector('.-scrollPoint')
			if (todayElement) {
				scrollbar.scrollIntoView(todayElement, {
					offsetTop: 0,
					onlyScrollIfNeeded: true,
				})
			}
		})
	},
}

document.addEventListener('DOMContentLoaded', function () {
	TvnSmoothScrollbar.init()
})

export default TvnSmoothScrollbar
